import React from 'react';
import { Session } from '../types';

interface StatusBarProps {
  session: Session | null;
  isLoading: boolean;
}

export const StatusBar: React.FC<StatusBarProps> = ({ session, isLoading }) => {
  if (!session && !isLoading) return null;

  const getStatusText = (status: string) => {
    switch (status) {
      case 'Searching':
        return '正在搜索...';
      case 'Analyzing':
        return '正在分析...';
      case 'Completed':
        return '研究完成';
      case 'Error':
        return '发生错误';
      default:
        return '准备中...';
    }
  };

  const getStatusClass = (status: string) => {
    switch (status) {
      case 'Searching':
      case 'Analyzing':
        return 'status-active';
      case 'Completed':
        return 'status-completed';
      case 'Error':
        return 'status-error';
      default:
        return '';
    }
  };

  return (
    <>
      {session && (
        <div className={`status-item ${getStatusClass(session.status)}`}>
          <span className="status-dot"></span>
          <span className="status-text">{getStatusText(session.status)}</span>
        </div>
      )}
      {isLoading && !session && (
        <div className="status-item status-active">
          <span className="status-dot"></span>
          <span className="status-text">正在连接...</span>
        </div>
      )}
    </>
  );
};
